import Vue from 'vue';
import { mapRbac } from '@plannrcrm/rbac';

// Expose can()/cannot()/canAny()/cannotAny()/canAll()/cannotAll()/isSuperAdmin()
// on every component so templates can guard UI elements with the rbac library.
Vue.mixin({
  methods: { ...mapRbac() },
});
